// Build timestamp injected by Vite (see vite.config.ts `define`).
// Used in the diagnostics panel + control room footer so a stale
// service-worker cache is visible.
declare const __BUILD_TS__: string;

export const BUILD_TS = (typeof __BUILD_TS__ !== 'undefined'
  ? __BUILD_TS__
  : 'dev') as string;

// rebuild trigger
